export const APPOINTMENT_STATUSES = [
  'scheduled',
  'confirmed',
  'in_progress',
  'completed',
  'cancelled',
  'no_show'
] as const;

export type AppointmentStatus = typeof APPOINTMENT_STATUSES[number];

export const getStatusLabel = (status: string, t?: any): string => {
  switch (status) {
    case 'scheduled': return t ? t('appointment.status.scheduled', 'Pendiente de confirmar') : 'Pendiente de confirmar';
    case 'confirmed': return t ? t('appointment.status.confirmed', 'Confirmada') : 'Confirmada';
    case 'in_progress': return t ? t('appointment.status.in_progress', 'En progreso') : 'En progreso';
    case 'completed': return t ? t('appointment.status.completed', 'Completada') : 'Completada';
    case 'cancelled': return t ? t('appointment.status.cancelled', 'Cancelada') : 'Cancelada';
    case 'no_show': return t ? t('appointment.status.no_show', 'No asiste') : 'No asiste';
    default: return status;
  }
};

export const getStatusColorClasses = (status: string): string => {
  switch (status) {
    case 'scheduled':
      return 'bg-amber-800/80 border-amber-600 text-white';
    case 'confirmed':
      return 'bg-green-800/80 border-green-600 text-white';
    case 'in_progress':
      return 'bg-blue-800/80 border-blue-600 text-white';
    case 'completed':
      return 'bg-purple-800/80 border-purple-600 text-white';
    case 'cancelled':
      return 'bg-red-800/80 border-red-600 text-white';
    case 'no_show':
      return 'bg-gray-800/80 border-gray-600 text-white';
    default:
      return 'bg-blue-800/80 border-blue-600 text-white';
  }
};

export const getStatusColorDot = (status: string): string => {
  switch (status) {
    case 'scheduled':
      return '#d97706'; // amber-600
    case 'confirmed':
      return '#22c55e'; // green-500
    case 'in_progress':
      return '#3b82f6'; // blue-500
    case 'completed':
      return '#a855f7'; // purple-500
    case 'cancelled':
      return '#ef4444'; // red-500
    case 'no_show':
      return '#6b7280'; // gray-500
    default:
      return '#3b82f6';
  }
};
